export const parseJPointer = (uri) => uri.includes('#')
    ? uri
        .substring(uri.indexOf('#') + 1)
        .split('/')
        .filter(Boolean)
    : [];
